import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { toPagination } from './utils';

export const IP_PORT_ADDRESS_ATTACK_SURFACE = graphql(`
  query ipPortAttackSurfaceQuery(
    $pagination: PaginationRequest
    $uuid: String
  ) {
    portsAttackSurface(
      filters: { submissionUuid: $uuid }
      pagination: $pagination
    ) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          port
          protocol
          ipAddresses {
            uuid
            ipv4Address
          }
        }
      }
    }
  }
`);

export function useIpPortAttackSurfaceQuery({
  entityUuid,
  pageNumber,
  pageSize,
}: {
  entityUuid: string;
  pageNumber: number;
  pageSize: number;
}) {
  const { loading, error, data } = useQuery(IP_PORT_ADDRESS_ATTACK_SURFACE, {
    variables: {
      uuid: entityUuid,
      pagination: toPagination(pageNumber, pageSize),
    },
  });

  //   const info = useMemo(() => {
  //     const entity = getFirstPaginatedNode(data?.entities);
  //     const alias = getFirstPaginatedNode(entity?.aliases);
  //     const insuredName = alias?.name;
  //     const coverages = getPaginatedNodes(entity?.coverages);
  //     const riskReportCoverages = coverages.map((coverage) => {
  //       return {
  //         name: coverage.name ?? 'N/A',
  //         score: coverage.score ?? 0,
  //         minScore: coverage.minScore ?? 0,
  //         maxScore: coverage.maxScore ?? 100,
  //       };
  //     });
  //     return { riskReportCoverages, entity, alias, insuredName, coverages };
  //   }, [data]);

  return {
    error,
    loading,
    data,
  };
}
